import React from 'react';

import { useApp } from '../../store/AppContext';

/* Bandeau du mode aperçu (manager qui consulte l'interface d'un membre). */
export default function PreviewBanner() {
  const { stopViewAs, viewAsDev } = useApp();
  return (
    <div className="flex items-center gap-[10px] bg-[#EAF1FB] [border:1px_solid_#B9D3F0] rounded-[10px] py-[10px] px-[16px] mb-[16px] text-[13px] text-navy">
      <i className="ti ti-eye text-[16px] text-[#2277BD] shrink-0" aria-hidden="true" />
      <div className="[flex:1]">
        Aperçu de l'interface de <strong>{viewAsDev?.nom || '…'}</strong> — lecture seule, aucune
        action n'est possible.
      </div>
      <button className="btn btn-sm text-[11px] shrink-0" onClick={stopViewAs}>
        <i className="ti ti-x" aria-hidden="true" /> Quitter l'aperçu
      </button>
    </div>
  );
}
